export {ClientLoggingItem as default};

/**
* Logging JS Entity
*
* @author      rsommerfeld <roni.s.sommerfeld@altice.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ClientLoggingItem {
  /**
   * URL Path
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  url_path;
  /**
   * Level Type (error or warning)
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  level;
  /**
   * Type Error (TypeError, ReferenceError ...)
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  type_error;
  /**
   * Browser Info
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  user_agent;
  /**
   * Message error
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  message;
  /**
   * Error full trace
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  stack;
  /**
   * Version App
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  app_version;
  /**
   * hash
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  hash;
}